
import React from 'react';
import LifeSkill2023 from 'views/LifeSkill2023';

const LifeSkillPage = () => {
  return <LifeSkill2023/>;
};

export default LifeSkillPage;
